export default __webpack_public_path__ + "static/media/node-foursquare-2.f8c18c79.jpg";